import React, { PropsWithChildren } from "react";

export interface AdornmentProps {
    className?: string;
    position: "start" | "end";
}

const Adornment: React.FC<PropsWithChildren<AdornmentProps>> = ({
    children,
    className = "field-control__adornment",
    position,
}) => {
    return (
        <div className={`${className} ${position === "start" ? className + "--start" : className + "--end"}`}>
            {children}
        </div>
    );
};

export default Adornment;
